<template>
  <div>
    <VueCookieAcceptDecline
        :forceCookies="true"
        :ref="'myPanel1'"
        :elementId="'myPanel1'"
        :debug="false"
        :position="'bottom'"
        :type="'floating'"
        :disableDecline="false"
        :transitionName="'slideFromBottom'"
        @status="cookieStatus"
        @clickedAccept="cookieClickedAccept"
        @clickedDecline="cookieClickedDecline"
    >

      <!-- Optional -->
      <div slot="message">
        Utilizamos cookies para garantizar que obtenga la mejor experiencia en nuestro sitio web.
      </div>

      <!-- Optional -->
      <div slot="declineContent">
        No acepto
      </div>

      <!-- Optional -->
      <div slot="acceptContent">
        Acepto
      </div>
    </VueCookieAcceptDecline>
    <register v-on:goToLogin="$emit('goToLogin')"></register>

  </div>
</template>

<script>
import Register from "../components/Register";
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

export default {
  name: "Register",
  components: {
    'register': Register,
    VueCookieAcceptDecline
  },
  data() {
    return {
      isVerifyEvent: false,
      status: null

    }
  },
  methods: {
    cookieStatus(status) {
      console.log('status: ' + status)
      this.status = status
    },
    cookieClickedAccept() {
      this.status = 'accept'
    },
    cookieClickedDecline() {
      console.log('here in decline')
      this.status = 'decline'
      this.$store.commit('updateIsChatActivated', false)

    }
  },

}
</script>

<style scoped>

</style>